import React from "react";
import AdStructure, {IAdStructure} from '../commons/adStructure/AdStructure';
import ConclusionCard from "../commons/conclusionCard/ConclusionCard";


import FirstStage from './components/firstStage';

export interface IAdLoadingProps extends IAdStructure {
  loading?: boolean;
}

const AdLoading = (props: IAdLoadingProps) => {
  return (
    <AdStructure
      cards={<FirstStage/>}
      rightSideCard={(
        <ConclusionCard
          loading={props.loading}
        />
      )}
      loading={props.loading}
    />
  )
};

AdLoading.defaultProps = {
  loading: true,
};

export default AdLoading;
